import React from "react";
import s from "./Checkbox.module.scss";
import { isNullish } from "utils/utils";

const Checkbox = ({ ref, oncheckFn, checked, indeterminate, disabled, readOnly, id }) => {
  return (
    <input
      ref={ref}
      id={id}
      disabled={disabled}
      readOnly={readOnly}
      type="checkbox"
      className={s.checkbox}
      onChange={readOnly ? () => { } : oncheckFn}
      checked={checked}
      {...(!isNullish(indeterminate) && {
        ref: (e) => {
          if (e) {
            e.indeterminate = indeterminate;
          }
        },
      })}
    />
  );
};

export default React.memo(Checkbox);
